import { createContext, useState, useEffect } from "react";
import axios from "../api/axios";
import { Navigate } from "react-router-dom";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
	const [auth, setAuth] = useState({});
	// Use a single state for account mode
	const [accountMode, setAccountMode] = useState("real"); // Default to 'real'
	// Optional: Fetch user data when auth changes
	// useEffect(() => {
	// 	if (auth?.id) {
	// 		const fetchUserData = async () => {
	// 			try {
	// 				const response = await axios.get(`/singleuser/${auth.id}`);
	// 				// setUserDt(response.data); // Uncomment if you need userDt
	// 			} catch (error) {
	// 				console.error("Error fetching user data:", error);
	// 			}
	// 		};
	// 		fetchUserData();
	// 	}
	// }, [auth?.id]); // Depend on auth.id

	const setRealAccountMode = () => {
		setAccountMode("real");
	};

	const setDemoAccountMode = () => {
		setAccountMode("demo");
	};

	console.log(auth);

	// if (!auth?.accesstoken) {
	// 	<Navigate to="/login" />;
	// } else {
	// 	<Navigate to="/dashboard" />;
	// }

	return (
		<AuthContext.Provider
			value={{
				auth,
				setAuth,
				accountMode, // Provide the single account mode state
				setRealAccountMode,
				setDemoAccountMode,
			}}>
			{children}
		</AuthContext.Provider>
	);
};

export default AuthContext;
